import { IVehicle } from "../../types/vehicle.type";

type PlanFilterFunction = (odometerLocavibe: number, createAt?: string) => boolean;

const PLAN_ODOMETER_FILTERS: Record<string, PlanFilterFunction> = {
  "SV 0KM": (odometerLocavibe: number) => odometerLocavibe >= 0 && odometerLocavibe <= 9999,
  "SV": (odometerLocavibe: number) => odometerLocavibe >= 10000 && odometerLocavibe <= 59999,
  "SV Semi": (odometerLocavibe: number) => odometerLocavibe >= 60000,
  "SV Finish": (_: number, createAt?: string) => {
    if (!createAt) return false;

    const today = new Date();
    const twoYearsAgo = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());

    // Retorna true se o veículo foi criado antes de 2 anos atrás
    return new Date(createAt) <= twoYearsAgo;
  },
};

export const filterVehiclesByPlan = (vehicles: IVehicle[], plan?: string): IVehicle[] => {
  if (!plan) {
    return vehicles; // Se não tiver plano, retorna todos os veículos
  }

  const isYourVibePlan = plan.includes("SV");

  if (isYourVibePlan) {
    // Filtro específico para planos SV (filtros baseados em odômetro e data)
    return vehicles.filter((vehicle) => {
      const odometerLocavibe = parseFloat(vehicle.odometerLocavibe);

      if (isNaN(odometerLocavibe)) {
        return false; // Ignora veículos sem odômetro ou com valor inválido
      }

      const filterFunction = PLAN_ODOMETER_FILTERS[plan];
      // ✅ Passa tanto o odômetro quanto a data de criação
      return filterFunction ? filterFunction(odometerLocavibe, vehicle.createdAt) : true;
    });
  } else {
    // Para outros planos, filtro padrão (só veículos com odômetro >= 1)
    return vehicles.filter((vehicle) => {
      const odometerLocavibe = parseFloat(vehicle.odometerLocavibe);
      return !isNaN(odometerLocavibe) && odometerLocavibe >= 1;
    });
  }
};

/**
 * Versão expandida da função que permite adicionar filtros personalizados
 * para planos específicos
 */
export const filterVehiclesByPlanWithCustomFilters = (
  vehicles: IVehicle[],
  plan?: string,
  customFilters?: Record<string, PlanFilterFunction>
): IVehicle[] => {
  if (!plan) {
    return vehicles;
  }

  const isYourVibePlan = plan.includes("SV");
  const planFilters = { ...PLAN_ODOMETER_FILTERS, ...customFilters };

  if (isYourVibePlan) {
    return vehicles.filter((vehicle) => {
      const odometerLocavibe = parseFloat(vehicle.odometerLocavibe);

      if (isNaN(odometerLocavibe)) {
        return false;
      }

      const filterFunction = planFilters[plan];
      // ✅ Passa tanto o odômetro quanto a data de criação
      return filterFunction ? filterFunction(odometerLocavibe, vehicle.createdAt) : true;
    });
  } else {
    return vehicles.filter((vehicle) => {
      const odometerLocavibe = parseFloat(vehicle.odometerLocavibe);
      return !isNaN(odometerLocavibe) && odometerLocavibe >= 1;
    });
  }
};